<script>
  // Canonical DaisyUI badge. Use for statuses, counts, and inline labels.
  // Domain-specific badges (state chips, visibility, age) should compose this or
  // live in components/badges/, mapping their value → variant in one place.
  import Icon from './icon.svelte'

  let {
    variant = 'neutral',
    size = 'md',
    outline = false,
    soft = false,
    icon = null,
    class: className = '',
    children,
    ...rest
  } = $props()

  const VARIANTS = {
    neutral: 'badge-neutral',
    primary: 'badge-primary',
    secondary: 'badge-secondary',
    accent: 'badge-accent',
    ghost: 'badge-ghost',
    info: 'badge-info',
    success: 'badge-success',
    warning: 'badge-warning',
    error: 'badge-error'
  }

  const SIZES = { xs: 'badge-xs', sm: 'badge-sm', md: '', lg: 'badge-lg' }

  const classes = $derived(
    [
      'badge',
      VARIANTS[variant] ?? VARIANTS.neutral,
      SIZES[size] ?? '',
      outline ? 'badge-outline' : '',
      soft ? 'badge-soft' : '',
      className
    ]
      .filter(Boolean)
      .join(' ')
  )
</script>

<span class={classes} {...rest}>
  {#if icon}
    <Icon name={icon} size="xs" />
  {/if}
  {@render children?.()}
</span>
